import common from '@page/common/js/common';
import cartDialog from '@page/favorite/components/cartDialog.vue';
import favoriteApp from '@global/components/member/favorite_2';
import Vue from 'vue';
import $ from 'jquery';
import AlertDialog from '@global/helpers/alertDialog';

const favorite = new Vue({
  el: '#app-favorite',
  components: {
    favoriteApp,
    cartDialog,
  },
  data: {
    isNotice: true, // 是否打開貨到通知功能
    btnDescription: {
      preShow: 'COMING SOON',
      soldout: '暫無庫存',
      notice: '暫銷售一空 ♡ 感謝熱烈支持',
      genernal: '請選擇尺寸',
      addbag: 'Add to bag',
    },
  },
});

$(document).on('click', '.open-dialog', function openDialog(e) {
  e.preventDefault();

  const $el = $(this);
  const elCustomMarketID = $el.data('custommarketid');

  $.ajax({
    type: 'GET',
    url: `${API_URL.MARKET_CONTENT}?CustomMarketID=${elCustomMarketID}`,
    dataType: 'json',
    xhrFields: {
      withCredentials: true,
    },
    error() {
      AlertDialog.alert('系統忙線中,請稍後再試');
    },
    success(res) {
      if (res.Code === 200) {
        $('#modal-market').modal('show');
        favorite.$refs.c_favorite.alldatas = res.Response;
        favorite.$refs.c_favorite.selectedID = res.Response.ColorID;
        favorite.$refs.c_favorite.dataisload = true;
      } else {
        AlertDialog.alert('系統忙線中,請稍後再試');
      }
    },
  });
});
